import { COLOR_REGEX } from "constants/regexes";
import { DirectUploadMedia } from "libs/directUpload";
import * as yup from "yup";

export const sectionStyleValidationSchema = yup.object({
  image: yup.mixed<DirectUploadMedia>().defined().nullable(),
  backgroundPicture: yup.mixed<DirectUploadMedia>().defined().nullable(),
  backgroundColor: yup
    .string()
    .defined()
    .matches(COLOR_REGEX, {
      message: "Color must be a valid hex code in the format #A8A8BB.",
      excludeEmptyString: true
    })
    .nullable()
});
